<script>
export default {
  name: 'AuthComponent',
  props : {
    access : Number
  },
  data : function(){
    return{
      auth : null
    }
  },
  mounted : function(){
    this.getSavedAuth();
  },
  watch:{
    $route (to){
      if(to.path == "/login") this.$emit("result", null)
      else this.getSavedAuth();
    }
  },
  methods:{
    verifyAuth(){
      fetch("https://app.danstechservices.us:8900/api/authenticate", { method: "POST", headers: { auth : JSON.stringify( this.auth ) } })
        .then(res => res.json())
        .then(res => {
          if(res.results != "Failed"){
            this.auth = res.results[0];
            this.saveVerifiedAuth();
            if(this.access != undefined && this.auth && this.auth.access < this.access) window.location.href = "/"; 
            this.$emit('result', this.auth);
          }
          else if(!window.location.href.toLowerCase().includes('login')) window.location.href = "/login"
        })
    },
    saveVerifiedAuth(){
      localStorage.setItem("auth", JSON.stringify( this.auth ));
    },
    getSavedAuth(){
      this.auth = localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : null;

      if(!this.auth && !window.location.href.toLowerCase().includes('login')) {
        window.location.href = "/login"
      }
      else this.verifyAuth();
    }
  }
}
</script>